import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import Chart from "chart.js";
import { NgForm } from '@angular/forms';
import { transporter } from '../institucional/mailer';
import { mainModule } from "process";
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import {Email} from '../institucional/smtp'

include: "https://smtpjs.com/v3/smtp.js";



@Component({
  selector: "app-institucional",
  templateUrl: "institucional.component.html"
})



export class InstitucionalComponent implements OnInit, OnDestroy {

  @ViewChild('formident',{static: true})formident: NgForm;
  nombree: any;
  correo: any;
  telefono: any;
  numeroAfiliado: any;
  mensaje: any;  

  isCollapsed = true;
  constructor() {
    this.nombree = {};
    this.correo  ={};
    this.telefono = {};  
    this.numeroAfiliado = {};  
    this.mensaje = {};  
  }

  
   ngOnInit() {
    
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("landing-page");

    var canvas: any = document.getElementById("chartBig");
    var ctx = canvas.getContext("2d");
    var gradientFill = ctx.createLinearGradient(0, 350, 0, 50);
    gradientFill.addColorStop(0, "rgba(228, 76, 196, 0.0)");
    gradientFill.addColorStop(1, "rgba(228, 76, 196, 0.14)");
    var chartBig = new Chart(ctx, {
      type: "line",
      responsive: true,
      data: {
        labels: [
          "JUN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC"
        ],
        datasets: [
          {
            label: "Data",
            fill: true,
            backgroundColor: gradientFill,
            borderColor: "#e44cc4",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#e44cc4",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#be55ed",
            //pointHoverBorderColor:'rgba(35,46,55,1)',
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [80, 160, 200, 160, 250, 280, 220, 190, 200, 250, 290, 320]
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },

        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#ccc",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        responsive: true,
        scales: {
          yAxes: [
            {
              barPercentage: 1.6,
              gridLines: {
                drawBorder: false,
                color: "rgba(0,0,0,0.0)",
                zeroLineColor: "transparent"
              },
              ticks: {
                display: false,
                suggestedMin: 0,
                suggestedMax: 350,
                padding: 20,
                fontColor: "#9a9a9a"
              }
            }
          ],

          xAxes: [
            {
              barPercentage: 1.6,
              gridLines: {
                drawBorder: false,
                color: "rgba(0,0,0,0)",
                zeroLineColor: "transparent"
              },
              ticks: {
                padding: 20,
                fontColor: "#9a9a9a"
              }
            }
          ]
        }
      }
    });
  }
  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("landing-page");
  }
  onsubmit2(){
    this.nombree = this.formident.value.nombre;
    this.correo  =this.formident.value.correo;
    this.telefono = this.formident.value.telefono;  
    this.numeroAfiliado = this.formident.value.numeroAfiliado;  
    this.mensaje = this.formident.value.mensaje; 
    this.formident.reset();
    window.open('mailto:dospu@unsl.edu.ar?subject=Formulario%20de%20contacto&body=Nombre%20completo:'+this.nombree+' %0ACorreo: '+this.correo+' %0ATeléfono: '+this.telefono+' %0AN° de Afiliado: '+this.numeroAfiliado+' %0AMensaje: '+this.mensaje);
  }
  /*public sendEmail(e: Event) {    
    emailjs.sendForm('service_6579hx8', 'template_eql8p98', e.target as HTMLFormElement, 'user_Ffw6WrrZGHUfdlmIAkjcD')
      .then((result: EmailJSResponseStatus) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
  }
*/


 
  
}
